import { render, staticRenderFns } from "./BinnacleMentionNotification.vue?vue&type=template&id=16edc2fd"
import script from "./BinnacleMentionNotification.vue?vue&type=script&lang=js"
export * from "./BinnacleMentionNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports